import { Column } from '@spoiler-alert/ui-library';
import React from 'react';
import NameColumn from './name-column';

const activeUserColumns = [
  new Column({
    field: 'lastName',
    displayName: 'Name',
    sortable: true,
    defaultSort: true,
    formatter(_, row) {
      return <NameColumn row={row} />;
    },
  }),
  new Column({ field: 'email', displayName: 'Email', sortable: true }),
  new Column({ field: 'siteName', displayName: 'Organization', sortable: true }),
  new Column({ field: 'privClass', displayName: 'User Role', sortable: true, formatter: (value) => value.displayName }),
];

export default activeUserColumns;
export { activeUserColumns };
